module.exports = __webpack_public_path__ + "media/images/icons/translate-e3f9392224b45a472abe2bf02eb11863.svg";